<template>
    <div>
        <app-gridviewmaintenance
            v-bind:parentData = "{
                tabHeaders: this.dataHeader,
                tabItems: this.dataItems,
                pageTitle: this.pageTitle,
                search: this.search,
            }"
            v-on:EditItem="editItemHandler($event)"
            v-on:DeleteItemHandler="deleteItemHandler($event)"
            v-on:NewPressedHandler="newRecordHandler"
        ></app-gridviewmaintenance>
    </div>
</template>

<script>
// import axios from 'axios';
import moment from 'moment';
import GridViewMaintenance from "../../../components/settings/workflowmaintenance/NewGrid";
//import GridView from '../../../components/common/GridView';

export default {
    components: {
        'app-gridviewmaintenance': GridViewMaintenance
    },  
    
    data() {
        return {
            pageTitle: this.$t('recworkflowmaintenance.workflowmaintenancelist'),
            dataHeader: [
                {text: this.$t('columns.actions'), value: 'action', sortable: false, width:'80px'},
                {text: this.$t('columns.workflowtype'), value: 'wftypedesc', width: '200px'},
                {text: this.$t('recworkflowmaintenance.recid'), value: 'recordid', width: '150px'},
                {text: this.$t('columns.staffcode'), value: 'staffcode', width: '150px'},
                {text: this.$t('columns.staffname'), value: 'psnname', width: '250px'},
                {text: this.$t('columns.company'), value: 'compnyname', width: '200px'},
                {text: this.$t('columns.recorddate'), value: 'recdate', width: '200px'},
            ],
            dataItems: [],
            leaveTypeHolder: [],
            isHr: false,
            errMsg: '',
            search: this.$route.params.search,
        }
    },

    methods: {
        // ⚠️ CHANGED: converted from .then().catch() to async/await
        async loadWorkflows() {
            try {
                // console.log("am i hr",this.isHr);
                // ⚠️ CHANGED: moved url selection above the dispatch, so res is declared once in the correct scope
                const url = this.isHr
                    ? `/workflowmaintenancenewHR/all/${this.$store.getters.userId}`
                    : `/workflowmaintenancenew/all`;

                const res = await this.$store.dispatch('get', {url});
                
                // ⚠️ CHANGED: replaced vm.dataItems with this.dataItems (no more vm alias needed in async)
                this.dataItems = res.data.rec;
                // console.log('dataitems', this.dataItems);

                for (let i = 0; i < this.dataItems.length; i++) {
                    if (this.dataItems[i].recdate) {
                        this.dataItems[i].recdate = moment(this.dataItems[i].recdate).format('YYYY-MM-DD');
                    }
                }

                // console.log('dataitems', this.dataItems);

            } catch (err) {
                // ⚠️ CHANGED: catch block now uses direct this instead of vm alias
                this.errMsg = err;
            }
        },

        loadLeaveType() {
            const vm = this;
            
            this.$store.dispatch('get', {
                url: `/leavetype/all`
            })
            .then (function (res) {
                this.leaveTypeHolder = res.data.rec;
            })
            .catch (err => {
                vm.isErr = !vm.isErr;
                vm.errMsg = err;
            });
            
        },

        detailHandler() {
            const vm = this;
            for (let i = 0; i < vm.dataItems.length; i++) {
                if (vm.dataItems[i].wftypeid == 3) {
                    let item = this.leaveTypeHolder.filter(val => val.id == vm.dataItems[i].detailid)[0]
                    vm.dataItems[i].detaildesc = item.leavedesc
                }
            }
        },

        async CheckisHR() {
            try {
                const res = await this.$store.dispatch('get', {url: `/checkishrlogin/${this.$store.getters.userId}`});

                // ⚠️ CHANGED: replaced 'this' with direct access (no more vm alias needed in async)
                if (res.data.rec.length >= 1) {
                    this.isHr = true;
                } else {
                    this.isHr = false;
                }
            } catch (err) {
                // ⚠️ CHANGED: catch block now uses direct this instead of vm alias
                this.errMsg = err;
            }
        },

        editItemHandler(item) {
            this.$router.push({name: 'workflowmaintenanceedit', params: { id: item.id, search: item.search  } });
        },

        newRecordHandler() {

          //  this.$router.push({name: 'workflowmaintenancenew'});
        }
    },

    async mounted() {
        await this.CheckisHR();
        await this.loadWorkflows();
    }
}
</script>